<script>
    import { createEventDispatcher } from 'svelte';
    import { collectionFolderColors } from '@repo/config/Global';

    /**
     * @typedef {Object} Props
     * @property {any} action
     * @property {any} currentColor
     * @property {any} [colors]
     * @property {boolean} [noAriaRole]
     * @property {any} [role]
     */
    let {
        action,
        currentColor,
        colors = [
            collectionFolderColors.YELLOW,
            collectionFolderColors.BLUE,
            collectionFolderColors.GREEN,
            collectionFolderColors.ORANGE,
            collectionFolderColors.PURPLE,
            collectionFolderColors.PINK,
        ],
        noAriaRole = false,
        role = null
    } = $props();

    const dispatch = createEventDispatcher();

    function handleMenuItemClick(e) {
        e.stopImmediatePropagation();
        dispatch('click', { action, dataSet: e.target.dataset });
    }
</script>

<li
    class="floating-menu-row interactive"
    role={noAriaRole ? null : role ?? 'menuitem'}
>
    <button
        onclick={handleMenuItemClick}
        data-color={colors[0]}
        class="interactive color {currentColor === colors[0] ? 'selected' : ''}"
        style="background-color:{colors[0]};"
></button>

    <button
        onclick={handleMenuItemClick}
        data-color={colors[1]}
        class="interactive color {currentColor === colors[1] ? 'selected' : ''}"
        style="background-color:{colors[1]};"
></button>

    <button
        onclick={handleMenuItemClick}
        data-color={colors[2]}
        class="interactive color {currentColor === colors[2] ? 'selected' : ''}"
        style="background-color:{colors[2]};"
></button>

    <button
        onclick={handleMenuItemClick}
        data-color={colors[3]}
        class="interactive color {currentColor === colors[3] ? 'selected' : ''}"
        style="background-color:{colors[3]};"
></button>

    <button
        onclick={handleMenuItemClick}
        data-color={colors[4]}
        class="interactive color {currentColor === colors[4] ? 'selected' : ''}"
        style="background-color:{colors[4]};"
></button>

    <button
        onclick={handleMenuItemClick}
        data-color={colors[5]}
        class="interactive color {currentColor === colors[5] ? 'selected' : ''}"
        style="background-color:{colors[5]};"
></button>
</li>

<style>
    .floating-menu-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        max-width: 20rem;
        color: #eee;
        padding: 1rem;
    }

    .floating-menu-row:hover {
        background-color: rgba(0, 0, 0, 0.3);
    }

    .color {
        display: flex;
        width: 1rem;
        height: 1rem;
        border-radius: 10rem;
        outline: 3px solid rgba(255, 255, 255, 0);
    }

    .color.selected {
        outline: 3px solid rgba(255, 255, 255, 1);
    }

    .color:hover {
        outline: 3px solid rgba(255, 255, 255, 1);
    }

    .color:not(:last-of-type) {
        margin-right: 0.25rem;
    }
</style>
